import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedAdjusterDocumentImagesQueryParamsType,
  GetDamagedAdjusterDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterDocumentImages/getDamagedAdjusterDocumentImagesQuery.type';

export const getDamagedAdjusterDocumentImagesFunction = (
  params: GetDamagedAdjusterDocumentImagesQueryParamsType,
): Promise<GetDamagedAdjusterDocumentImagesQueryResponseType[]> => {
  const generateUrl = () => {
    switch (params.type) {
      case 'damaged':
        return `/property/reports/${params.id}/accident_users/damaged/images/adjuster/document/`;

      case 'body':
        return `/body/reports/${params.id}/images/adjuster/document/`;

      case 'culprit':
        return `/property/reports/${params.id}/accident_users/culprit/images/adjuster/document/`;

      case 'initial':
        return `/initial/reports/${params?.id}/images/adjuster/document/`;
    }
  };

  return fetchApi.get(generateUrl(), {
    params:
      params.type === 'damaged' ? { damaged_id: params?.damagedId } : undefined,
  });
};
